<template>
    <router-view />
    <!-- 应用已挂载，但首次导航/会话与菜单尚未解析：只显示加载层（样式见 index.html .tita-boot-loading） -->
    <div v-if="bootState.loading" class="tita-boot-loading">
        <div class="tita-boot-loading__spinner"></div>
        <div>加载中...</div>
    </div>
</template>

<script setup lang="ts">
import useSettingsStore from '@/store/modules/settings';
import { handleThemeStyle } from '@/utils/http/theme';
import { nextTick, onMounted } from 'vue';
import { bootState } from '@/utils/bootState';
// import {tencentImLogin} from "@/plugins/useTencentIm";


onMounted(async() => {
    await nextTick(() => {
      handleThemeStyle(useSettingsStore().theme);// 初始化主题样式
    });

 // await tencentImLogin()
});
</script>
